import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { fetchSaleStateBtn } from '@/utils';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import ProductSubmit from '../ProductSubmit';
import cls from 'classnames';
import styles from './index.module.less';
import { throttle } from 'lodash';
import ProductPrice from '../ProductPrice';
import PrimeButton from '../PrimeButton';
import ComponentsErrorBoundary from '@/components/ErrorBoundary/ComponentsErrorBoundary';
import ProductRedirectButton from '../ProductRedirectButton';

@inject('area', 'product', 'meta', 'abtest')
@observer
class StickyTabBar extends Component {
  state = {
    primeButtonVisible: false,
  };
  componentDidMount() {
    const { productDetail, setStateValue, toggleStickyTabBar } = this.props.product;
    const { changePageToolBarPosition } = this.props.meta;
    // 将购物车栏元素存入到mobx中
    setStateValue('eleStickyTabBar', this.eleStickyTabBar);
    changePageToolBarPosition();
    // // 切换产品页时底部导航栏无需过度动画
    if (!productDetail.is_camera && this.eleStickyTabBar) {
      toggleStickyTabBar(false, 'instant');
      // 到overview的时候导航拦出现
      window.addEventListener('scroll', this.handleScrollListener);
    }
  }

  getCommodityInfo = () => {
    const { curSelectCommodity, productCarts, isSelectPersonalized, curPersonalizedCommodities } = this.props.product;
    const { displays } = curSelectCommodity;
    let name = curSelectCommodity.info?.name;
    let cover = displays[0] ? displays[0]['url_s'] : '';
    if (isSelectPersonalized && curPersonalizedCommodities.length > 0) {
      name = curPersonalizedCommodities.filter((o) => o.type === 'cameras')[0]['info']['name'];
      cover = curPersonalizedCommodities.filter((o) => o.type === 'cameras')[0]['displays'][0]['url_s'];
    } else {
      productCarts.slice(1).forEach((o) => {
        name += '、' + o.product_name + '-' + o.info.name;
      });
    }
    return {
      name,
      cover,
    };
  };

  getButtonText = () => {
    // 导流产品文案或销售状态文案
    const { productDetail, curSelectCommodity } = this.props.product;
    const redirectData = ThirdPartyPlatformConfig.getRedirectData({
      pid: productDetail.id,
      cid: curSelectCommodity.id,
    });
    return redirectData?.text || fetchSaleStateBtn(curSelectCommodity);
  };

  eleSecBottom = null;

  eleStickyTabBar = null;

  // 如果展示Overview模块则显示导航栏
  handleScrollListener = throttle(() => {
    let { eleSecBottom, eleStickyTabBar } = this;
    const { toggleStickyTabBar } = this.props.product;
    this.eleSecBottom = eleSecBottom ?? document.getElementById('pSecBottom');
    if (eleSecBottom && eleStickyTabBar) {
      requestAnimationFrame(() => {
        const pSecBottomOffsetTop = eleSecBottom.getBoundingClientRect().top;
        toggleStickyTabBar(pSecBottomOffsetTop < eleStickyTabBar.clientHeight);
      });
    }
  }, 500);

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollListener);
  }

  getCommodityName = () => {
    const {
      country: { X_Language },
      LANG,
    } = this.props.area;
    const { productCarts, isSelectPersonalized, curSelectCommodityCount, curSelectCommodity, productDetail } =
      this.props.product;
    const { VersionConfig = {} } = productDetail;
    const mainProduct = productCarts[0];

    try {
      const split_symbol = {
        'zh_cn': '、',
        'ja_jp': '、',
        'zh_tw': '，',
        'ko_kr': '，',
      };
      const split = split_symbol[X_Language] ? split_symbol[X_Language] : ', ';

      let commodityName = mainProduct.info.name;
      if (isSelectPersonalized) {
        commodityName = VersionConfig?.isAttributeGroup
          ? `${commodityName} ×${curSelectCommodityCount}`
          : `${commodityName.includes('||') ? commodityName.split('||')[0] + '|| ' : ''} ${
              LANG['productNew.personalizedPackage']
            }  ×${curSelectCommodityCount}`;
      }

      let name = '';
      productCarts.forEach((item, index) => {
        name += `${index >= 1 ? split : ''}${index === 0 ? commodityName : item.product_name}${
          item.count > 1 ? ` × ${item.count}` : ''
        }`;
      });

      return name;
    } catch (e) {
      return curSelectCommodity?.info?.name ?? '';
    }
  };

  // Prime按钮的显隐影响页面样式
  onPrimeButtonVisible = (visible) => {
    this.setState({
      primeButtonVisible: visible,
    });
  };

  render() {
    const { productDetail, eleStickyTabBarVisible } = this.props.product;
    const { primeButtonVisible } = this.state;

    return (
      <section
        id='pStickyTabBar'
        ref={(ref) => (this.eleStickyTabBar = ref)}
        className={cls({
          [styles.StickyTabBar]: true,
          [styles.hide]: !eleStickyTabBarVisible,
          [styles.StickyTabBarAbt]: true,
        })}
      >
        <div className={styles.innerWrap}>
          <div className={styles.l}>
            <div className={styles.pName}>{productDetail.info?.name}</div>
            <div className={styles.cName}>{this.getCommodityName()}</div>
          </div>
          <div className={styles.r}>
            <ProductPrice from='stickyBar' />
            <ComponentsErrorBoundary name='StickyBar PrimeButton'>
              {productDetail.is_camera && (
                <PrimeButton onVisible={this.onPrimeButtonVisible} style={{ marginLeft: 40 }} from='stickyBar' />
              )}
            </ComponentsErrorBoundary>

            <ProductSubmit from='stickyBar' style={{ marginLeft: primeButtonVisible ? 8 : 40 }} />
            {/* BESTBUY导流按钮 */}
            <ProductRedirectButton style={{ marginLeft: 8 }} from='stickyBar' />
          </div>
        </div>
      </section>
    );
  }
}

export default StickyTabBar;
